import React, { useEffect, useState } from "react";
import LoadingSpinner from "../Shared/LoadingSpinner/LoadingSpinner";
import Sidebar from "../Shared/Sidebar/Sidebar";
import { FaGraduationCap } from "react-icons/fa";
import { SiHtml5 } from "react-icons/si";
import { SiCss3 } from "react-icons/si";
import { SiJavascript } from "react-icons/si";
import { SiPhp } from "react-icons/si";
import { SiJava } from "react-icons/si";
import { SiPython } from "react-icons/si";
import { SiCsharp } from "react-icons/si";
import { GrMysql } from "react-icons/gr";
import { SiMongodb } from "react-icons/si";
import { SiReact } from "react-icons/si";
import { SiExpress } from "react-icons/si";
import { SiLaravel } from "react-icons/si";
import { SiFirebase } from "react-icons/si";
import { SiTailwindcss } from "react-icons/si";
import { SiBootstrap } from "react-icons/si";
import { SiGithub } from "react-icons/si";

import "./About.modules.css";

const About = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, []);

  return (
    <section>
      <Sidebar></Sidebar>

      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <div className="lg:pl-[220px]">
          <div className="px-4 lg:px-20 w-full min-h-screen">
            <div className="py-6 lg:py-12">
              <div className="space-y-12 lg:space-y-28 animate__animated animate__fadeIn">
                <section>
                  <div className="mb-6 lg:mb-10 mt-12 lg:mt-5">
                    <h1 className="title-text lg:mt-0 text-4xl lg:text-[55px] font-bold text-[#04BF00] tracking-[.07em]">
                      About{" "}
                      <span className="text-dark-blue-xxl dark:text-white">
                        Myself
                      </span>
                    </h1>
                  </div>

                  <div className="form-text text-lg grid grid-cols-1 lg:grid-cols-2 gap-y-2">
                    <div className="space-y-3">
                      <p>
                        <span className="text-dark-blue-xxl dark:text-[#abb7db]">
                          Full Name:{" "}
                        </span>
                        <span className="text-dark-blue-xxl dark:text-[#dbdbdb]">
                          Ishtiyak Ali Rifat
                        </span>
                      </p>
                      <p>
                        <span className="text-dark-blue-xxl dark:text-[#abb7db]">
                          Age :{" "}
                        </span>
                        <span className="text-dark-blue-xxl dark:text-[#dbdbdb]">
                          23
                        </span>
                      </p>
                      <p>
                        <span className="text-dark-blue-xxl dark:text-[#abb7db]">
                          Nationality :{" "}
                        </span>
                        <span className="text-dark-blue-xxl dark:text-[#dbdbdb]">
                          Bangladeshi
                        </span>
                      </p>
                      <p>
                        <span className="text-dark-blue-xxl dark:text-[#abb7db]">
                          Freelance :{" "}
                        </span>
                        <span className="text-dark-blue-xxl dark:text-[#dbdbdb]">
                          Available
                        </span>
                      </p>
                      <p>
                        <span className="text-dark-blue-xxl dark:text-[#abb7db]">
                          Address :{" "}
                        </span>
                        <span className="text-dark-blue-xxl dark:text-[#dbdbdb]">
                          Thakurgaon, Bangladesh
                        </span>
                      </p>
                    </div>
                    <div className="space-y-4">
                      <p>
                        <span className="text-dark-blue-xxl dark:text-[#abb7db]">
                          Whatsapp :{" "}
                        </span>
                        <span className="text-dark-blue-xxl dark:text-[#dbdbdb]">
                          +880 1734446466
                        </span>
                      </p>
                      <p>
                        <span className="text-dark-blue-xxl dark:text-[#abb7db]">
                          Email :{" "}
                        </span>
                        <span className="text-dark-blue-xxl dark:text-[#dbdbdb]">
                          rifatishtiyak@gmail.com
                        </span>
                      </p>
                      <p>
                        <span className="text-dark-blue-xxl dark:text-[#abb7db]">
                          Language :{" "}
                        </span>
                        <span className="text-dark-blue-xxl dark:text-[#dbdbdb]">
                          Bengali, English
                        </span>
                      </p>
                    </div>
                  </div>
                </section>

                <section>
                  <h4 className="title-text mb-6 lg:mb-10 lg:mt-0 text-4xl lg:text-[55px] font-bold text-[#04BF00] tracking-[.07em]">
                    My{" "}
                    <span className="text-dark-blue-xxl dark:text-white">
                      Education
                    </span>
                  </h4>
                  <div className="grid grid-cols-1 lg:grid-rows-2 lg:grid-flow-col gap-y-12 gap-x-4">
                    <div className="flex">
                      <div className="mr-4 relative">
                        <div className="p-2 bg-[#04BF00] rounded-full z-50 relative">
                          <FaGraduationCap size={"1.2em"} />
                        </div>
                        <div className="border-r-[2px] border-dark-blue-xxl dark:border-[#abb7db] h-full vrLine z-0"></div>
                      </div>
                      <div className="form-text text-dark-blue-xxl dark:text-[#dbdbdb]">
                        <h5 className="text-2xl font-semibold mb-2">
                          American International University-Bangladesh
                        </h5>
                        <div className="space-y-1 dark:text-[#abb7db]">
                          <p>
                            Bachelor of Science in Computer Science &
                            Engineering
                          </p>
                          <p>Major in Software Engineering</p>
                          <p>April, 2018 - May, 2022</p>
                          <p>Dhaka, Bangladesh</p>
                        </div>
                      </div>
                    </div>

                    <div className="flex">
                      <div className="mr-4 relative">
                        <div className="p-2 bg-[#04BF00] rounded-full z-50 relative">
                          <FaGraduationCap size={"1.2em"} />
                        </div>
                        <div className="border-r-[2px] border-dark-blue-xxl dark:border-[#abb7db] h-full vrLine z-0"></div>
                      </div>
                      <div className="form-text text-dark-blue-xxl dark:text-[#dbdbdb]">
                        <h5 className="text-2xl font-semibold mb-2">
                          Pirganj Pilot High School
                        </h5>
                        <div className="space-y-1 dark:text-[#abb7db]">
                          <p>Secondary School Certificate (SSC)</p>
                          <p>January, 2010 - April, 2015</p>
                          <p>Pirganj, Thakurgaon</p>
                        </div>
                      </div>
                    </div>

                    <div className="flex">
                      <div className="mr-4 relative">
                        <div className="p-2 bg-[#04BF00] rounded-full z-50 relative">
                          <FaGraduationCap size={"1.2em"} />
                        </div>
                        <div className="border-r-[2px] border-dark-blue-xxl dark:border-[#abb7db] h-full vrLine z-0"></div>
                      </div>
                      <div className="form-text text-dark-blue-xxl dark:text-[#dbdbdb]">
                        <h5 className="text-2xl font-semibold mb-2">
                          Pirganj Model Govt. Primary School
                        </h5>
                        <div className="space-y-1 dark:text-[#abb7db]">
                          <p>Primary Education Certificate (PEC)</p>
                          <p>January, 2005 - December 2009</p>
                          <p>Pirganj, Thakurgaon</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section>
                  <h4 className="title-text mb-6 lg:mb-10 lg:mt-0 text-4xl lg:text-[55px] font-bold text-[#04BF00] tracking-[.07em]">
                    My{" "}
                    <span className="text-dark-blue-xxl dark:text-white">
                      Skills
                    </span>
                  </h4>

                  <h4 className="form-text text-xl mb-4 text-dark-blue-xxl dark:text-[#abb7db]">
                    Language, Database & Others:
                  </h4>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiHtml5 size={"3em"} className="mx-auto"></SiHtml5>
                        <p className="form-text">HTML5</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiCss3 size={"3em"} className="mx-auto"></SiCss3>
                        <p className="form-text text-center">CSS3</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiJavascript
                          size={"3em"}
                          className="mx-auto"
                        ></SiJavascript>
                        <p className="form-text text-center">JavaScript</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiPhp size={"3em"} className="mx-auto"></SiPhp>
                        <p className="form-text text-center">PHP</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiJava size={"3em"} className="mx-auto"></SiJava>
                        <p className="form-text text-center">Java</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiCsharp size={"3em"} className="mx-auto"></SiCsharp>
                        <p className="form-text text-center">C#</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiPython size={"3em"} className="mx-auto"></SiPython>
                        <p className="form-text text-center">Python</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <GrMysql size={"3em"} className="mx-auto"></GrMysql>
                        <p className="form-text text-center">MySQL</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiMongodb size={"3em"} className="mx-auto"></SiMongodb>
                        <p className="form-text text-center">MongoDB</p>
                      </div>
                    </div>
                  </div>

                  <h4 className="form-text text-xl mt-12 mb-4 text-dark-blue-xxl dark:text-[#abb7db]">
                    Libraries, Frameworks and Tools:
                  </h4>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiReact size={"3em"} className="mx-auto"></SiReact>
                        <p className="form-text">React JS</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiExpress size={"3em"} className="mx-auto"></SiExpress>
                        <p className="form-text text-center">Express JS</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiLaravel size={"3em"} className="mx-auto"></SiLaravel>
                        <p className="form-text text-center">Laravel</p>
                      </div>
                    </div>

                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiTailwindcss
                          size={"3em"}
                          className="mx-auto"
                        ></SiTailwindcss>
                        <p className="form-text text-center">Tailwind CSS</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiBootstrap
                          size={"3em"}
                          className="mx-auto"
                        ></SiBootstrap>
                        <p className="form-text text-center">Bootstrap</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiFirebase
                          size={"3em"}
                          className="mx-auto"
                        ></SiFirebase>
                        <p className="form-text text-center">Firebase</p>
                      </div>
                    </div>
                    <div className="skill-card bg-[#0e223f] hover:text-[#04BF00] hover:cursor-pointer py-8 flex justify-center rounded-md">
                      <div className="space-y-3">
                        <SiGithub size={"3em"} className="mx-auto"></SiGithub>
                        <p className="form-text text-center">GitHub</p>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default About;
